/**
 * Header save status indicator for dosimetry workflow.
 * Mirrors StrategySaveStatus pattern.
 */

import { AlertTriangle } from 'lucide-react';

import { useDosimetryPersistence } from '../hooks/use-dosimetry-persistence';

import { SaveStatusIndicator } from '@/components/viewer/save-status-indicator';

export function DosimetrySaveStatus({ caseId }: { caseId: string }) {
    const persistence = useDosimetryPersistence({ caseId });

    if (persistence.restoreError) {
        return (
            <div className="flex items-center gap-1.5 text-xs text-destructive">
                <AlertTriangle className="h-3 w-3" />
                Failed to restore dosimetry state
            </div>
        );
    }

    // Only show indicator if state has been saved at least once
    if (persistence.status === 'idle' && !persistence.lastSavedAt) {
        return null;
    }

    return (
        <SaveStatusIndicator
            status={persistence.status}
            lastSavedAt={persistence.lastSavedAt}
            retryCount={persistence.retryCount}
            onSaveNow={persistence.saveNow}
        />
    );
}
